import { api } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const PAG_DDT_EMPTY = { stato: "non_pagato", importo: "", mezzo: "bonifico", data: new Date().toISOString().slice(0, 10) };
const MEZZI = [["bonifico", "Bonifico"], ["pos", "POS / Carta"], ["contanti", "Contanti"], ["assegno", "Assegno"], ["riba_rid", "RiBa / RID"], ["altro", "Altro"]];
const STATI = [["non_pagato", "Da pagare"], ["pagato", "Pagato tutto"], ["parziale", "Parziale"]];

export const pagDdtDaOcr = (o) => ({ ...PAG_DDT_EMPTY, stato: o?.stato_pagamento === "pagata" || o?.fattura?.stato_pagamento === "pagata" ? "pagato" : "non_pagato",
  mezzo: o?.fattura?.metodo_pagamento || "bonifico" });

export const DdtPagamentoFields = ({ value, onChange, testid = "ddtnew" }) => {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-2" data-testid={`${testid}-pag`}>
      <div className="text-[10px] font-semibold text-muted-foreground uppercase">Pagamento del DDT</div>
      <div className="grid grid-cols-3 gap-1">
        {STATI.map(([v, l]) => (
          <button key={v} type="button" onClick={() => set("stato", v)} data-testid={`${testid}-pag-${v}`}
            className={`h-10 rounded-md border text-sm ${value.stato === v ? "border-primary bg-primary text-primary-foreground" : "border-input bg-background"}`}>{l}</button>
        ))}
      </div>
      {value.stato !== "non_pagato" && (
        <div className="grid grid-cols-2 gap-2">
          {value.stato === "parziale" && (
            <div className="col-span-2"><Label>Importo pagato €</Label><Input inputMode="decimal" value={value.importo} onChange={(e) => set("importo", e.target.value)} data-testid={`${testid}-pag-importo`} /></div>
          )}
          <div><Label>Metodo</Label>
            <select className="w-full h-10 rounded-md border border-input bg-background px-2 text-sm" value={value.mezzo} onChange={(e) => set("mezzo", e.target.value)} data-testid={`${testid}-pag-metodo`}>
              {MEZZI.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
            </select>
          </div>
          <div><Label>Data</Label><Input type="date" value={value.data} onChange={(e) => set("data", e.target.value)} data-testid={`${testid}-pag-data`} /></div>
        </div>
      )}
    </div>
  );
};

// Campi da inviare insieme al DDT (stato manuale) + registrazione del pagamento dopo la creazione
export const pagDdtCampi = (p) => p.stato === "non_pagato" ? { stato_pagamento: "non_pagato" }
  : { stato_pagamento: p.stato, mezzo_pagamento: p.mezzo, data_pagamento: p.data };

export const registraPagamentoDdt = async (did, p) => {
  if (!did || p.stato === "non_pagato") return;
  const importo = Number(String(p.importo).replace(",", "."));
  if (p.stato === "parziale" && !(importo > 0)) return;
  try {
    await api.post(`/ddt/${did}/pagamenti`, { saldo: p.stato === "pagato", importo: p.stato === "parziale" ? importo : null, mezzo_pagamento: p.mezzo, data_pagamento: p.data });
  } catch (e) {
    if (e?.response?.status === 403) toast.info("DDT salvato come pagato; il pagamento lo registra l'amministratore");
  }
};
